import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export const UseDesktop = (props: any) => {
  return (
    <>
      <Container>
        <Row>
          <Col>
            <div className="page-denied text-center align-middle">
              <img src="../../../images/desktop-only.png" alt="" />
              <h5 className="mt-3">Desktop Only</h5>
              <p>สามารถใช้งานได้บน Desktop เท่านั้น</p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
